import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CentralClienteContaDetalharComponent } from './central-cliente-conta-detalhar.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path:':id', component: CentralClienteContaDetalharComponent}
  ])],
  exports: [RouterModule]
})
export class CentralClienteContaDetalharRoutingModule { }
